import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TabComponent } from '../../../components/tab/tab.component';
import { APITableComponent } from '../../../components/table/api-table/api-table.component';
import { TabLayoutComponent } from '../../../components/tab-layout/tab-layout.component';
import { TableRow } from '../../../components/table/table.interface';

@Component({
  selector: 'app-sales-performance-tab',
  imports: [APITableComponent, TabLayoutComponent],
  templateUrl: './sales-performance-tab.component.html',
  providers: [
    { provide: TabComponent, useExisting: SalesPerformanceTabComponent },
  ],
})
export class SalesPerformanceTabComponent extends TabComponent {
  override name = this.dictionaryService.get('SalesPerformance');

  constructor(private router: Router) {
    super();
  }

  public async main(): Promise<void> {}

  onUserRowClick = (row: TableRow) => {
    const userId = row.value['userId'];
    const userName = row.value['Name'];
    if (userId) {
      this.router.navigate(['/users', userId], {
        state: { userName },
      });
    }
  };
}
